import { api } from 'api';
import { call, put, SagaReturnType } from 'redux-saga/effects';
import { improvementAreaActions } from 'store/data/improvementArea';
import { JwtFeature } from 'utility/jwt';

import { operationWrapper } from './operationWrapper';

// Fetches improvement areas and loads the improvementArea domain.
// Gated behind JwtFeature.Improvements — same feature flag as Suggestions
// and Actions since areas are the grouping mechanism for both.
export function* initializeImprovementAreas() {
  function* work(tenantId: string) {
    const {
      improvementAreaDomain,
    }: SagaReturnType<typeof api.getImprovementAreas> = yield call(
      api.getImprovementAreas,
      { tenantId },
    );

    yield put(improvementAreaActions.setDomain(improvementAreaDomain));
  }

  yield call(operationWrapper, work, JwtFeature.Improvements);
}
